<template>
  <LibraryListItem>
    <div class="job-profile-col">
      <div class="text-h6 text-body-2 ellipsis-col">
        {{ profile.title || '' }}
      </div>
      <div
        v-if="profile.hris_job_code"
        class="job-code text-body-3 ellipsis-col"
      >
        {{ profile.hris_job_code }}
      </div>
    </div>

    <div class="text-body-2 job-level-col">
      {{ profile.job_level || '' }}
    </div>

    <div class="alerts-col">
      <StatusPill
        :status-key="alertStatus.key"
        :label="alertStatus.label"
      />
    </div>

    <div class="text-body-2 form-submitted-by-col">
      {{ federalSubmission?.created_by?.name || '' }}
    </div>

    <div class="text-body-2 flsa-status-col">
      {{
        federalSubmission?.is_flsa_exempt
          ? 'Exempt'
          : federalSubmission?.is_flsa_exempt === false
            ? 'Non-exempt'
            : ''
      }}
    </div>

    <div class="text-body-2 exemption-basis-col">
      {{ formatExemptionBasis(federalSubmission?.primary_exemption_category) }}
    </div>
  </LibraryListItem>
</template>

<script setup>
import { computed } from 'vue';
import LibraryListItem from '@/components/shared/LibraryListItem.vue';
import StatusPill from '@/components/shared/StatusPill.vue';
import {
  formatExemptionBasis,
  getFederalLatestSubmission,
  getProfileAlertStatus,
} from '@/components/library/flsaSurveys/helpers';

const props = defineProps({
  item: { type: Object, required: true },
});

const profile = computed(() => props.item?.profile || {});

const federalSubmission = computed(() => getFederalLatestSubmission(props.item));

const alertStatus = computed(() => getProfileAlertStatus(props.item));
</script>

<style lang="less" scoped>
.job-profile-col,
.job-level-col,
.alerts-col,
.form-submitted-by-col,
.flsa-status-col,
.exemption-basis-col {
  justify-self: start;
  padding-left: 16px;
}

.alerts-col {
  display: flex;
  align-items: center;
}

.job-code {
  color: @text-light;
}
</style>
